export default __webpack_public_path__ + "static/media/desktop_tc1_Cn.034df310.webp";